import {Injectable} from '@angular/core';
import {PortalDataService} from "../portal-data/portal-data.service";
import {RequestService} from "../request/request.service";
import {FeatureFlagsService} from "../feature-flag/feature-flags.service";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  currentTheme: string = "";

  logoUrl: string;

  logoObserver: MutationObserver;

  constructor(private portalDataService: PortalDataService,
              private featureFlagsService: FeatureFlagsService,
              private requestService: RequestService) {
    this.portalDataService.portalComponentsLoaded.subscribe((_) => {
      // What to do here?
    });
  }

  async init() {
    await this.setLogoUrl();
  }

  setPortalTheme(definitionId: string) {
    this.generatePortalTheme(definitionId, false);
    this.currentTheme = definitionId;
  }

  unsetPortalTheme() {
    this.getThemeNode().textContent = "";
    this.currentTheme = "";
  }

  async generatePortalTheme(definitionId: string = null, cache: boolean = true) {

    const effectiveDefinition = await this.portalDataService.getEffectiveDefinition();
    const definitionIdToUse = definitionId || effectiveDefinition.id
    try {
      const response: any = await this.requestService.createRequest()
        .controller("servicely.core.Portal")
        .method("generatePortalTheme")
        .data({ definitionId: definitionIdToUse, cache: cache })
        .execute();

      const result = response.data.first;
      const errResult = response.data.second;
      const status = response.data.third;
      if (status) {
        this.getThemeNode().textContent = result;

        this.generatePortalThemeHTML(effectiveDefinition);

        this.currentTheme = effectiveDefinition?.Name?.value;
      } else {
        console.error(`ThemeService.generatePortalTheme failed for definition ${definitionIdToUse}`, errResult);
      }
    } catch (e) {
      console.error(`ThemeService.generatePortalTheme failed for definition ${definitionIdToUse}`, e);
    }
  }

  /**
   * this is for changing stuff that the theme gives us that cannot be done with CSS - like things in the HEAD
   */
  private generatePortalThemeHTML(effectiveDefinition: any) {
    // document.querySelector('title').innerHTML = 'gnarly'; // add to definition
  }

  private getThemeNode() {
    return  document.querySelector("#sb-theme-definition");
  }

  private async setLogoUrl() {

    // Might have been set via some SASS variables in _root-portal-style.scss
    const existingLogoUrl = window.getComputedStyle(document.documentElement).getPropertyValue("--logo-url");

    // Otherwise get from the fields that are on PortalDefinition and PortalStyle
    const result = await fetch("/generated_anon_css_variables");
    const css = await result.text();
    this.logoUrl = css.match(/--logo-url: (.*);/)?.[1] || existingLogoUrl;

    // Set existing logo elements in the DOM
    if (this.logoUrl) {
      document.querySelectorAll("#servicely-logo").forEach(e => {
        e.setAttribute("src", this.logoUrl);
      });
    }

    // Set new logo elements in the DOM
    this.logoObserver = new MutationObserver((records, observer) => {
      if (this.logoUrl) {
        let isSet = false;
        for (const record of records) {
          record.addedNodes.forEach(node => {
            if (node.nodeType == Node.ELEMENT_NODE) {
              const element = (node as Element);
              element.querySelectorAll("#servicely-logo").forEach(e => {
                e.setAttribute("src", this.logoUrl);
                isSet = true;
              });
            }
          });
          if (isSet) {
            observer.disconnect();
          }
        }
      }
    });

    this.logoObserver.observe(document, { childList: true, subtree: true });
  }
}
